/**
 * Deferred banner loading for fdc-home-slideshow.
 * Only the first slide loads on page load; others load when shown or preloaded.
 */
(() => {
  function loadDeferredPicture(picture) {
    if (picture.dataset.loaded === 'true') return;

    picture.querySelectorAll('source[data-deferred-srcset]').forEach((source) => {
      source.srcset = source.dataset.deferredSrcset;
      if (source.dataset.deferredSizes) source.sizes = source.dataset.deferredSizes;
      source.removeAttribute('data-deferred-srcset');
      source.removeAttribute('data-deferred-sizes');
    });

    const img = picture.querySelector('img[data-deferred-src]');
    if (img) {
      img.src = img.dataset.deferredSrc;
      if (img.dataset.deferredSrcset) img.srcset = img.dataset.deferredSrcset;
      if (img.dataset.deferredSizes) img.sizes = img.dataset.deferredSizes;
      img.removeAttribute('data-deferred-src');
      img.removeAttribute('data-deferred-srcset');
      img.removeAttribute('data-deferred-sizes');
    }

    picture.dataset.loaded = 'true';
    picture.classList.remove('fdc-banner-image--deferred');
  }

  function loadSlideImages(slide) {
    slide.querySelectorAll('.fdc-banner-image--deferred').forEach(loadDeferredPicture);
  }

  function initCarousel(carousel) {
    const slides = carousel.querySelectorAll('.slideshow__slide');
    if (!slides.length) return;

    const preloadNext = carousel.dataset.preloadNext !== 'false';

    const getActiveIndex = () => {
      let index = 0;
      slides.forEach((slide, i) => {
        if (slide.classList.contains('is-active')) index = i;
      });
      return index;
    };

    const loadAroundActive = () => {
      const index = getActiveIndex();
      loadSlideImages(slides[index]);
      if (preloadNext && slides.length > 1) {
        loadSlideImages(slides[(index + 1) % slides.length]);
      }
    };

    loadAroundActive();

    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
          if (mutation.target.classList.contains('is-active')) {
            loadAroundActive();
          }
        }
      });
    });

    slides.forEach((slide) => {
      observer.observe(slide, { attributes: true, attributeFilter: ['class'] });
    });
  }

  function init() {
    document.querySelectorAll('slide-show[data-defer-banner-images]').forEach(initCarousel);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', (event) => {
    const carousel = event.target.querySelector('slide-show[data-defer-banner-images]');
    if (carousel) initCarousel(carousel);
  });
})();
